// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-container {
  /* max-height: calc(100vh - 365px); */
  overflow: auto;
}

table {
  overflow: auto;
  border-collapse: collapse;
  width: 100%;
}

.table-spec {
  width: 100%;
  max-width: 100%;
  empty-cells: show;
  border: 0;
}

td, th {
  border: 1px solid #dddddd;
  text-align: left;
  font-weight: normal;
}

td {
  padding: 6px 10px;
}

th {
  border-top: none;
  position: sticky;
  top: 0;
  padding: 10px;
  background: #212529;
  color: #ffffff;
  font-size: 14px;
  z-index: 1;
}

tbody tr:nth-child(even) {
  background-color: #f2f2f2;
}

td .txtarea {
  width: 100% !important;
}

td textarea:hover {
  border: 1px solid gray !important;
}

.first td:nth-child(1) {
  color: teal;
}

.alignIt{
  margin-right: 5px;
  float: right;
  /* padding-bottom: 1px; */
}

.labelStyle{
  font-family: ProximaNova-Regular, TeXGyreHerosRegular, Helvetica, Arial, sans-serif; 
  font-size: 14px;
}

span[aria-label-action]:hover:after {
  content: attr(aria-label-action);
  padding: 4px 8px;
  position: absolute;
  right: 30px;
  top: -10px;
  white-space: nowrap;
  z-index: 999999;
  background:teal;
  color: white;
  border-radius: 5px;
  font-size: 16px;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/View/core/master-data-management/qr-details/qr-details.component.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,mFAAmF;EACnF,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA,g3FAAg3F","sourcesContent":[".table-container {\r\n  /* max-height: calc(100vh - 365px); */\r\n  overflow: auto;\r\n}\r\n\r\ntable {\r\n  overflow: auto;\r\n  border-collapse: collapse;\r\n  width: 100%;\r\n}\r\n\r\n.table-spec {\r\n  width: 100%;\r\n  max-width: 100%;\r\n  empty-cells: show;\r\n  border: 0;\r\n}\r\n\r\ntd, th {\r\n  border: 1px solid #dddddd;\r\n  text-align: left;\r\n  font-weight: normal;\r\n}\r\n\r\ntd {\r\n  padding: 6px 10px;\r\n}\r\n\r\nth {\r\n  border-top: none;\r\n  position: sticky;\r\n  top: 0;\r\n  padding: 10px;\r\n  background: #212529;\r\n  color: #ffffff;\r\n  font-size: 14px;\r\n  z-index: 1;\r\n}\r\n\r\ntbody tr:nth-child(even) {\r\n  background-color: #f2f2f2;\r\n}\r\n\r\ntd .txtarea {\r\n  width: 100% !important;\r\n}\r\n\r\ntd textarea:hover {\r\n  border: 1px solid gray !important;\r\n}\r\n\r\n.first td:nth-child(1) {\r\n  color: teal;\r\n}\r\n\r\n.alignIt{\r\n  margin-right: 5px;\r\n  float: right;\r\n  /* padding-bottom: 1px; */\r\n}\r\n\r\n.labelStyle{\r\n  font-family: ProximaNova-Regular, TeXGyreHerosRegular, Helvetica, Arial, sans-serif; \r\n  font-size: 14px;\r\n}\r\n\r\nspan[aria-label-action]:hover:after {\r\n  content: attr(aria-label-action);\r\n  padding: 4px 8px;\r\n  position: absolute;\r\n  right: 30px;\r\n  top: -10px;\r\n  white-space: nowrap;\r\n  z-index: 999999;\r\n  background:teal;\r\n  color: white;\r\n  border-radius: 5px;\r\n  font-size: 16px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
